
Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.Route = Greenmile.RouteSummary.Route || {};
Greenmile.RouteSummary.Route.Grid = (function () {

    function Grid () {

        Greenmile.RouteSummary.Grid.apply(this, arguments);

        this.entity = 'RouteSummaryRoutes';
        this.containerGrid = "#RouteSummary #routeGrid #grid";
        this.entityToActionGrid = 'RouteView';
        this.countCustomColumns = 2;

        this.addCustomColumns = function (columns) {

            var routeSummary = {
                id: 'routeSummary',
                name: Monet.I18n.getResourcesByKey('Route.Grid.odometerTitle'),
                width: 230,
                field: 'routePercentage',
                cssClass: "cell-row",
                sortable: true,
                resizable: false,
                entity: this.entity,
                formatter: function (_row, _cell, _value, _column, dataContext) {

                    if (!dataContext.model.attributes.route) {
                        dataContext.model.attributes.route = dataContext.model.attributes;
                    }

                    if(dataContext.model.attributes?.stopStats) {
                      dataContext.model.attributes.route = {
                        ...dataContext.model.attributes.route,
                        route: dataContext.model.attributes.route,
                        stopStats: dataContext.model.attributes.stopStats
                      };
                    }

                    return Greenmile.Utils.gridRouteProgressBar(dataContext.model.attributes.route);
                }
            };

            var routeStatus = {
                id: 'routeStatus',
                name: '',
                field: 'routeStatus',
                width: 50,
                cssClass: "cell-row",
                sortable: false,
                resizable: false,
                entity: this.entity,
                formatter: function (row, cell, value, column, dataContext) {

                    if (!dataContext.model.attributes.route) {
                        dataContext.model.attributes.route = dataContext.model.attributes;
                    }

                    dataContext.model.attributes.route.totalStopsInProgress = dataContext.model.attributes.totalStopsInProgress;
                    return Greenmile.Utils.renderRouteStatus(dataContext.model.attributes.route);
                }
            };

            columns.unshift(routeSummary);
            columns.unshift(routeStatus);

            return columns;

        };

        this.getInstanceOfMenu = function () {
            return new Greenmile.RouteSummary.Route.Menu();
        };

    }

    return Grid;

}());
